/** @typedef {'openai' | 'gemini' | 'claude'} AnalyseProvider */

/** Payload keys are chatgpt/gemini/claude; fan-out UI uses openai instead of chatgpt. */
export const PROVIDER_ORDER = /** @type {AnalyseProvider[]} */ ([
	"openai",
	"gemini",
	"claude",
]);

/** @param {string} p */
export function toAnalyseProvider(p) {
	return p === "chatgpt" ? "openai" : p;
}

/** @param {AnalyseProvider | string} p */
export function toPayloadProvider(p) {
	return p === "openai" ? "chatgpt" : p;
}
